import { Component, OnInit } from '@angular/core';
import { BaseResponse } from '../../../models/response';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToasterService } from '../../../shared/services/toaster.service';
import { Router } from '@angular/router';
import { GetterSetterService } from '../../../shared/services/getter-setter.service';
import { AuthService } from '../../services/auth.service';
import { BusinessEntityService } from '../../../shared/services/business-entity.service';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss']
})
export class UpdatePasswordComponent implements OnInit {

  updateProfileForm: FormGroup;
  updatePassForm: FormGroup;
  isSubmitted: boolean = false;
  activeStep1: boolean = true;
  activeStep2: boolean = false;
  activeStep3: boolean = false;
  businessDetailsFilled: any;
  isSubmittedProfile: boolean = false;
  entityType: string;
  isTopazAccess: any;
  isSapphireAccess: any;
  isOnyxAccess: any;
  email: any;
  userEmail: any;
  notifiactionEmail: any;
  phoneNum: any;
  userName: any;
  middleName: any;
  lastName: any;
  aadhaarNum: any;
  constructor(
    private toaster: ToasterService,
    private router: Router,
    private fBuild: FormBuilder,
    private authService: AuthService,
    private businessService: BusinessEntityService,
  ) {
  }

  ngOnInit(): void {
    this.email = localStorage.getItem('UserId');
    this.businessService.getUserProfileData().subscribe((response: BaseResponse) => {
      if (response.status == 'SUCCESS') {
        this.userEmail = response.response[0].email;
        this.notifiactionEmail = response.response[0].notificationEmail;
        this.phoneNum = response.response[0].phonenumer;
        this.userName = response.response[0].username;
        this.lastName = response.response[0].lastname;
        this.middleName = response.response[0].middlename;
        this.aadhaarNum = response.response[0].aadhaar;
        this.formInitialization();
      } else {
        this.toaster.showError(response.message);
      }
    });
  }

  OpenForm(step: string) {

  }
  formInitialization() {
    this.updateProfileForm = this.fBuild.group({
      username: [this.userName, [Validators.required]],
      middlename: [this.middleName, []],
      lastname: [this.lastName, [Validators.required]],
      email: [this.userEmail, [Validators.required, Validators.email]],
      notificationEmail: [this.notifiactionEmail, [Validators.required, Validators.email]],
      phonenumer: [this.phoneNum, [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"), Validators.minLength(10), Validators.maxLength(10)]],
      aadhaar: [this.aadhaarNum, [Validators.minLength(12), Validators.maxLength(12), Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]]
    });
    this.updatePassForm = this.fBuild.group({
      curentpassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(16), Validators.pattern(new RegExp('(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=.\\[\\]*?])(?=\\S+$).{8,16}'))]],
      newpassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(16), Validators.pattern(new RegExp('(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=.\\[\\]*?])(?=\\S+$).{8,16}'))]],
      confirmpassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(16), Validators.pattern(new RegExp('(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=.\\[\\]*?])(?=\\S+$).{8,16}'))]],
    });
  }

  get f() { return this.updatePassForm.controls; }

  updatePassword() {
    this.isSubmitted = true;
    if (this.updatePassForm.valid && this.email) {
      if (this.updatePassForm.value.newpassword == this.updatePassForm.value.confirmpassword) {
        this.updatePassForm.value.changePasswordFromLogin = true;
        this.updatePassForm.value.email = this.email;
        this.authService.changePassowrd(this.updatePassForm.value).subscribe((response: BaseResponse) => {
          if (response.status == 'SUCCESS') {
            this.toaster.showSuccess('Password changed successfylly.');
            // this.router.navigate(['dashboard']);
          } else {
            this.toaster.showError(response.message);
          }
        });
      } else {
        this.toaster.showError("New Password and confirmation password do not match");
      }
    }
  }

  updateProfile() {
    this.isSubmittedProfile = true;
    if (this.updateProfileForm.valid) {
      this.businessService.updateUserProfileData(this.updateProfileForm.value).subscribe((response: BaseResponse) => {
        if (response.status == 'SUCCESS') {
          this.toaster.showSuccess('Profile updated successfully.');
        } else {
          this.toaster.showError(response.message);
        }
      });
    }
  }

  toDashboard() {
    this.router.navigate(['dashboard']);
  }

}
